import DownloadIcon from '@mui/icons-material/Download';
import { Button, CircularProgress, Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useManifestTemplateDownload } from 'components/StudyDashboard/CaseManifest/useManifestTemplateDownload';
import React, { FunctionComponent } from 'react';

interface UploadManifestProps {
  withTitle?: boolean;
}

const UploadManifest: FunctionComponent<React.PropsWithChildren<UploadManifestProps>> = ({ withTitle = true }) => {
  const downloadTemplateMutation = useManifestTemplateDownload();

  return (
    <Grid container direction={'column'}>
      {withTitle && (
        <Grid item>
          <Typography variant="h4" marginBottom={2}>
            Slides manifest
          </Typography>
        </Grid>
      )}
      <Grid item>
        <Typography variant="body1">Download a template for slide-to-case assignments and metadata.</Typography>
      </Grid>
      <Grid item>
        <Button
          color="primary"
          onClick={() => downloadTemplateMutation.mutate()}
          disabled={downloadTemplateMutation.isLoading}
          startIcon={<DownloadIcon />}
        >
          Download template
          {downloadTemplateMutation.isLoading && (
            <Box sx={{ display: 'flex' }}>
              <CircularProgress sx={{ marginLeft: 2 }} color="inherit" size={20} />
            </Box>
          )}
        </Button>
      </Grid>
    </Grid>
  );
};

export default UploadManifest;
